// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

html, body {
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  font-family: Helvetica;
  background: aliceblue;
  overflow: hidden;
}

.b {
  font-weight: bold;
}

.Game {
  position: absolute;
  background: white;
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
}

.Score {
  position: absolute;
  font-size: 18px;
  top: 10px;
  left: 10px;
}

.Name {
  position: absolute;
  right: 10px;
  top: 10px;
}

.Name-input {
  box-sizing: border-box;
  font-size: 18px;
  padding-bottom: 4px;
  border: none;
  border-bottom: 1px solid transparent;
  text-align: right;
}

.Name-input:hover {
  border-bottom: 1px solid #eee;
}

.Name-input:focus {
  outline: none;
}

.SnowflakeContainer {
  position: absolute;
}

.ConfettiContainer {
  position: absolute;
  transition: opacity 0.5s linear;
  opacity: 0;
}

.CandyContainer {
  width: 100px;
  position: absolute;
}

.GameOver {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.GameOver-inner {
  flex: none;
  max-width: 50%;
}

.GameOver-label {
  font-family: 'Passion One', Helvetica, sans-serif;
  font-size: 32px;
  text-align: center;
}

.Highscore {
  font-family: Helvetica, sans-serif;
  color: rgba(233, 100, 106, 1);
  font-size: 18px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./app/game.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,iDAAiD;EACjD,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nhtml, body {\n  padding: 0;\n  margin: 0;\n  height: 100%;\n  width: 100%;\n  font-family: Helvetica;\n  background: aliceblue;\n  overflow: hidden;\n}\n\n.b {\n  font-weight: bold;\n}\n\n.Game {\n  position: absolute;\n  background: white;\n  top: 10px;\n  left: 10px;\n  right: 10px;\n  bottom: 10px;\n}\n\n.Score {\n  position: absolute;\n  font-size: 18px;\n  top: 10px;\n  left: 10px;\n}\n\n.Name {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n\n.Name-input {\n  box-sizing: border-box;\n  font-size: 18px;\n  padding-bottom: 4px;\n  border: none;\n  border-bottom: 1px solid transparent;\n  text-align: right;\n}\n\n.Name-input:hover {\n  border-bottom: 1px solid #eee;\n}\n\n.Name-input:focus {\n  outline: none;\n}\n\n.SnowflakeContainer {\n  position: absolute;\n}\n\n.ConfettiContainer {\n  position: absolute;\n  transition: opacity 0.5s linear;\n  opacity: 0;\n}\n\n.CandyContainer {\n  width: 100px;\n  position: absolute;\n}\n\n.GameOver {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.GameOver-inner {\n  flex: none;\n  max-width: 50%;\n}\n\n.GameOver-label {\n  font-family: 'Passion One', Helvetica, sans-serif;\n  font-size: 32px;\n  text-align: center;\n}\n\n.Highscore {\n  font-family: Helvetica, sans-serif;\n  color: rgba(233, 100, 106, 1);\n  font-size: 18px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
